import script from "./CreditsPlansItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsPlansItem.vue?vue&type=script&setup=true&lang=js"

import "./CreditsPlansItem.vue?vue&type=style&index=0&id=0001ce64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2_clean-css@5.3.3_c_e59ecb87855333ab161cabc1a794339b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0001ce64"]])

export default __exports__